export const defaultAccentColour = '#682f91';
